import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { UserInviteFormValues } from '@/app/module/user/component/form/specs'
import { ERROR_INVITE_USER } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useInviteUser = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [createOrgInvite, res] = esApi.endpoints.createOrgInvite.useMutation()

  const inviteUser = useCallback(
    async (inviteData: UserInviteFormValues): Promise<boolean> => {
      try {
        await createOrgInvite({
          orgId: orgId.toString(),
          body: inviteData,
        }).unwrap()

        dispatch(
          createNotification({
            'invite-user-success': {
              type: 'success',
              message: 'Invitation sent successfully.',
            },
          }),
        )

        return true
      } catch (error) {
        dispatch(
          createNotification({
            'invite-user-error': {
              type: 'error',
              message: getErrorMessage(error, ERROR_INVITE_USER),
            },
          }),
        )

        return false
      }
    },
    [orgId, dispatch, createOrgInvite],
  )

  return [inviteUser, res] as const
}
